import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/customers/commercial-partners')({
  staticData: toStaticData(CRT_ROUTES['/crt/customers/commercial-partners']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
